import React from "react";
import styles from "./TermsCondition.module.css";

const TermsCondition = () => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Terms & Condition</h2>
        <p className={styles.date}>Updated 02/22/2023</p>

        <div className={styles.textContainer}>
          <h4 className={styles.title}>Accepting These Terms</h4>
          <p className={styles.text}>
            This document, our rules, policies and the other documents
            referenced make up our Terms and Conditions (“Terms”). The Terms are
            a legally binding contract between you and chitchatgame.com. This
            contract sets out your rights and responsibilities when you use our
            app. Please read them carefully.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Changes</h4>
          <p className={styles.text}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            may amend the Terms at any time by posting a revised version on the
            app. The revised version will be effective at the time we post it.
            If we change the Terms in a way that reduces your rights or
            increases your responsibilities, we will provide you with a
            notification.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Communications</h4>
          <p className={styles.text}>
            By creating an Account on chitchatgame.com, you agree to subscribe
            to newsletters, marketing or promotional materials and other
            information we may send. However, you may opt out of receiving any,
            or all, of these communications from us by emailing at us,
            info@chitchatgame.com.
            <a href="mailto: info@chitchatgame.com" className={styles.text}>
              info@chitchatgame.com
            </a>
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Accounts</h4>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              When you create an account with chitchatgame.com, you guarantee
              that you are above the age of 18, and that the information you
              provide us is accurate, complete, and current at all times.
              Inaccurate, incomplete, or obsolete information may result in the
              immediate termination of your account on Service.
            </li>
            <li className={styles.text}>
              You are responsible for maintaining the confidentiality of your
              account and password, including but not limited to the restriction
              of access to your computer and/or account. You agree to accept
              responsibility for any and all activities or actions that occur
              under your account and/or password, whether your password is with
              our Service or a third-party service. You must notify us
              immediately upon becoming aware of any breach of security or
              unauthorized use of your account.
            </li>
            <li className={styles.text}>
              We reserve the right to refuse service, terminate accounts, remove
              or edit content at our sole discretion.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.title}
            >
              chitchatgame.com
            </a>{" "}
            Pledge
          </h4>
          <p className={styles.text}>
            We are absolutely committed to maintaining and upgrading our app
            continuously. As users want new features built in, and augmentations
            to current systems made, we will do our best to make the changes in
            a timely manner. Although we cannot guarantee we can make every
            specific change for our users, we will be constantly making the
            software better and pledge to do everything we can to make the
            changes our users want.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>License to Use our Services</h4>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              Subject to these Terms, chitchatgame.com grants you a limited,
              personal, non-exclusive, non-transferable license to use of the
              app for your personal use and not for resale or further
              distribution. Your right to use the app is limited by all terms
              and conditions set forth in these Terms.
            </li>
            <li className={styles.text}>
              Except for your pre-existing rights and this license granted to
              you, we and our licensors retain all right, title and interest in
              and to the app, including all related intellectual property
              rights. chitchatgame.com is protected by applicable intellectual
              property laws, including United States copyright law and
              international treaties.
            </li>
            <li className={styles.text}>
              Except as otherwise explicitly provided in these Terms or as may
              be expressly permitted by applicable law, you will not, and will
              not permit or authorize any third party to: (i) reproduce, modify,
              translate, enhance, decompile, disassemble, reverse engineer or
              create derivative works of any of our Services; (ii) rent, lease
              or sublicense access to any of our Services; or (iii) circumvent
              or disable any security or technological features or measures of
              our Services.
            </li>{" "}
            <li className={styles.text}>
              Any action constituting a violation of this section will result in
              the immediate cancellation of your account.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Refunds & Liability</h4>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              By accessing and signing up on our app, you acknowledge that
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              does not issue partial refunds. However, you are at liberty to
              cancel your use of the app at any given time.
            </li>

            <li className={styles.text}>
              You agree that chitchatgame.com shall not be responsible for the
              wrong use of the service and it further disassociates itself from
              any eventualities that may occur after the door is opened.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Feedback</h4>
          <p className={styles.text}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            may provide you with a mechanism to provide feedback, suggestions,
            and ideas, if you choose, about the app ("Feedback"). You agree that
            we may, in our sole discretion, use the Feedback you provide to us
            in any way, including in future enhancements and modifications to
            the app. You hereby grant to us and our assigns a perpetual,
            worldwide, fully transferable, sub- licensable, irrevocable, royalty
            free license to use, reproduce, modify, create derivative works
            from, distribute, and display the Feedback in any manner any for any
            purpose, without in any media, software, or technology of any kind
            now existing or developed in the future, without any obligation to
            provide attribution or compensation to you or any third party.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Prohibited Uses</h4>
          <p className={styles.text}>
            You may use chitchatgame.com only for lawful purposes and in
            accordance with Terms. You agree not to use the app:
          </p>
          <ol type="a" className={styles.list}>
            <li className={styles.text}>
              In any way that violates any applicable state, federal or
              international law or regulation.
            </li>
            <li className={styles.text}>
              For the purpose of exploiting, harming, or attempting to exploit
              or harm minors in any way by exposing them to inappropriate
              content or otherwise.
            </li>{" "}
            <li className={styles.text}>
              To impersonate or attempt to impersonate another user.
            </li>
            <li className={styles.text}>
              In any way that infringes upon the rights of others, or in any way
              is illegal, threatening, fraudulent, or harmful, or in connection
              with any unlawful, illegal, fraudulent, or harmful purpose or
              activity.
            </li>
            <li className={styles.text}>
              To engage in any other conduct that restricts or inhibits anyone’s
              use or enjoyment of the app.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>NO Use by Minors</h4>
          <p className={styles.text}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            is intended only for access and use by individuals at least eighteen
            (18) years old. By accessing or using the app, you warrant and
            represent that you are at least eighteen (18) years of age and with
            the full authority, right, and capacity to enter into this agreement
            and abide by all of the terms and conditions of Terms. If you are
            not at least eighteen (18) years old, you are prohibited from both
            the access and usage of the app.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Third Party Links</h4>

          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              may contain links to third party sites or services that are not
              owned or controlled by us.
            </li>
            <li className={styles.text}>
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              has no control over, and assumes no responsibility for the
              content, privacy policies, or practices of any third party sites
              or services. We do not warrant the offerings of any of these
              entities/individuals or their sites.
            </li>{" "}
            <li className={styles.text}>
              YOU ACKNOWLEDGE AND AGREE THAT chitchatgame.com SHALL NOT BE
              RESPONSIBLE OR LIABLE, DIRECTLY OR INDIRECTLY, FOR ANY DAMAGE OR
              LOSS CAUSED OR ALLEGED TO BE CAUSED BY OR IN CONNECTION WITH USE
              OF OR RELIANCE ON ANY SUCH ONTENT, SERVICES AVAILABLE ON OR
              THROUGH ANY SUCH THIRD PARTY WEB SITES OR SERVICES.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Disclaimer</h4>
          <p className={styles.text}>
            YOUR USE OF{" "}
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            AND THE SERVICE CONTENT IS AT YOUR SOLE RISK. chitchatgame.com AND
            THE SERVICE CONTENT EACH ARE PROVIDED ON AN "AS IS" AND "AS
            AVAILABLE" BASIS. chitchatgame.com EXPRESSLY DISCLAIMS ALL
            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT
            NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. WE DO NOT
            GUARANTEE THE ACCURACY, COMPLETENESS, OR USEFULNESS OF THE SERVICES
            OR ANY SERVICE CONTENT, AND YOU RELY ON THE SERVICES AND SERVICE
            CONTENT AT YOUR OWN RISK. ANY MATERIAL THAT YOU ACCESS OR OBTAIN
            THROUGH THE APP IS DONE AT YOUR OWN DISCRETION AND RISK AND YOU WILL
            BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER OR LOSS OF
            DATA THAT RESULTS FROM THE DOWNLOAD OF ANY MATERIAL THROUGH OUR
            SERVICES. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN,
            OBTAINED BY YOU FROM US OR THROUGH OR FROM OUR SERVICES WILL CREATE
            ANY WARRANTY NOT EXPRESSLY STATED IN THIS AGREEMENT.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Limitation of Liability</h4>
          <p className={styles.text}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO,
            DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER
            INTANGIBLE LOSSES (EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY
            OF THESE DAMAGES), RESULTING FROM YOUR USE OF THE APP. UNDER NO
            CIRCUMSTANCES WILL THE TOTAL LIABILITY OF US AND LICENSORS OF ALL
            KINDS ARISING OUT OF OR RELATED TO YOUR USE OF THE APP AND SERVICE
            CONTENT (INCLUDING BUT NOT LIMITED TO WARRANTY CLAIMS), REGARDLESS
            OF WHETHER ANY ACTION OR CLAIM IS BASED ON CONTRACT, TORT, OR
            OTHERWISE, EXCEED THE AMOUNTS, IF ANY, THAT YOU HAVE PAID TO US FOR
            YOUR USE OF{" "}
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            .
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Indemnity</h4>
          <p className={styles.text}>
            You will indemnify and hold chitchatgame.com harmless from any
            costs, damages, expenses, and liability caused by your use of the
            app, your violation of these Terms, or your violation of any rights
            of a third party through use of{" "}
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            .
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Termination</h4>

          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              may terminate or suspend your account and bar access to the
              Service immediately, without prior notice or liability, under our
              sole discretion, for any reason whatsoever and without limitation,
              including but not limited to a breach of Terms.
            </li>
            <li className={styles.text}>
              If you wish to terminate your account, you may simply discontinue
              using Service.
            </li>{" "}
            <li className={styles.text}>
              All provisions of Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity
              and limitations of liability.
            </li>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Governing Law</h4>

          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              These Terms shall be governed and construed in accordance with the
              laws of the state of New York without regard to its conflict of
              law provisions
            </li>
            <li className={styles.text}>
              Our failure to enforce any right or provision of these Terms will
              not be considered a waiver of those rights. If any provision of
              these Terms is held to be invalid or unenforceable by a court, the
              remaining provisions of these Terms will remain in effect. These
              Terms constitute the entire agreement between us regarding our
              Service and supersede and replace any prior agreements we might
              have had between us regarding Service.
            </li>{" "}
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Changes to Service</h4>
          <p className={styles.text}>
            <a
              href="https://chitchatgame.com/"
              target="_blank"
              rel="noreferrer"
              className={styles.text}
            >
              chitchatgame.com
            </a>{" "}
            reserves the right to withdraw or amend our Service, and any service
            or material we provide via Service, in our sole discretion without
            notice. We will not be liable if for any reason all or any part of
            the Service is unavailable at any time or for any period. From time
            to time, we may restrict access to some parts of Service, or the
            entire Service, to users, including registered users.
          </p>{" "}
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Waiver and Severability</h4>

          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              No waiver by{" "}
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              of any term or condition set forth in the Terms shall be deemed a
              further or continuing waiver of such term or condition or a waiver
              of any other term or condition, and any failure of
              <a
                href="https://chitchatgame.com/"
                target="_blank"
                rel="noreferrer"
                className={styles.text}
              >
                chitchatgame.com
              </a>{" "}
              to assert a right or provision under Terms shall not constitute a
              waiver of such right or provision.
            </li>
            <li className={styles.text}>
              If any provision of the Terms is held by a court or other tribunal
              of competent jurisdiction to be invalid, illegal or unenforceable
              for any reason, such provision shall be eliminated or limited to
              the minimum extent such that the remaining provisions of the Terms
              will continue in full force and effect.
            </li>{" "}
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Acknowledgement</h4>
          <p className={styles.text}>
            BY USING OUR APP, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS &
            CONDITIONS AND AGREE TO BE BOUND BY THEM.
          </p>{" "}
        </div>
      </div>
    </section>
  );
};

export default TermsCondition;
